var _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgIconPoly = function SvgIconPoly(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 26 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.507 7.673c-.463-.264-1.057-.264-1.586 0l-3.699 2.18-2.51 1.387-3.633 2.18c-.463.264-1.057.264-1.586 0l-2.84-1.717a1.61 1.61 0 0 1-.793-1.388V7.012c0-.528.265-1.056.793-1.387l2.84-1.651c.463-.264 1.057-.264 1.586 0l2.84 1.717c.463.265.793.793.793 1.388v2.18l2.51-1.454V5.56a1.63 1.63 0 0 0-.792-1.387L8.145 1.067c-.463-.264-1.057-.264-1.585 0L1.143 4.238C.614 4.502.35 5.031.35 5.56v6.21c0 .528.264 1.056.793 1.387l5.35 3.104c.463.265 1.057.265 1.586 0l3.633-2.113 2.51-1.454 3.633-2.113c.463-.265 1.057-.265 1.586 0l2.84 1.651c.463.264.793.793.793 1.387v3.303a1.63 1.63 0 0 1-.793 1.387l-2.774 1.652c-.463.264-1.057.264-1.586 0l-2.84-1.652a1.61 1.61 0 0 1-.793-1.387v-2.114l-2.51 1.454v2.18c0 .528.264 1.056.793 1.387l5.35 3.104c.463.265 1.057.265 1.586 0l5.35-3.104a1.61 1.61 0 0 0 .793-1.388v-6.275a1.63 1.63 0 0 0-.793-1.387l-5.35-3.105Z",
    fill: "#8247E5"
  })));
};

export default SvgIconPoly;